/* SVG icon set — ported from matches-shared.jsx. Same icon names. */

export type IconName =
  | 'search'
  | 'calendar'
  | 'list'
  | 'chevronL'
  | 'bell'
  | 'share'
  | 'bookmark'
  | 'bookmarkOutline'
  | 'whistle'
  | 'home'
  | 'matches'
  | 'feed'
  | 'profile'
  | 'settings'
  | 'pin';

interface IconProps {
  name: IconName;
  size?: number;
  color?: string;
  title?: string;
}

export function Icon({ name, size = 18, color = 'currentColor', title }: IconProps) {
  const s = { width: size, height: size };
  const stroke = {
    stroke: color,
    strokeWidth: 2,
    fill: 'none' as const,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
  };

  const paths: Record<IconName, JSX.Element> = {
    search: (
      <>
        <circle cx="11" cy="11" r="7" {...stroke} />
        <path d="m21 21-4.3-4.3" {...stroke} />
      </>
    ),
    calendar: (
      <>
        <rect x="3" y="5" width="18" height="16" rx="2" {...stroke} />
        <path d="M3 10h18M8 3v4M16 3v4" {...stroke} />
      </>
    ),
    list: <path d="M4 6h16M4 12h16M4 18h16" {...stroke} />,
    chevronL: <path d="M15 6l-6 6 6 6" {...stroke} />,
    bell: (
      <>
        <path d="M6 8a6 6 0 0 1 12 0c0 7 3 8 3 8H3s3-1 3-8Z" {...stroke} />
        <path d="M10 21a2 2 0 0 0 4 0" {...stroke} />
      </>
    ),
    share: (
      <path
        d="M12 3v13M8 7l4-4 4 4M5 15v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4"
        {...stroke}
      />
    ),
    bookmark: (
      <path
        d="M6 3h12v18l-6-4-6 4V3Z"
        fill={color}
        stroke={color}
        strokeLinejoin="round"
      />
    ),
    bookmarkOutline: <path d="M6 3h12v18l-6-4-6 4V3Z" {...stroke} />,
    whistle: (
      <>
        <circle cx="15" cy="12" r="6" {...stroke} />
        <path d="M9 12H3M6 9l-3-3M6 15l-3 3" {...stroke} />
      </>
    ),
    home: (
      <path
        d="M3 11l9-8 9 8v10a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1V11Z"
        {...stroke}
      />
    ),
    matches: (
      <>
        <rect x="3" y="5" width="18" height="14" rx="2" {...stroke} />
        <path d="M3 10h18" {...stroke} />
      </>
    ),
    feed: <path d="M4 6h13M4 12h16M4 18h10" {...stroke} />,
    profile: (
      <>
        <circle cx="12" cy="8" r="4" {...stroke} />
        <path d="M4 21c0-4 4-7 8-7s8 3 8 7" {...stroke} />
      </>
    ),
    settings: (
      <>
        <circle cx="12" cy="12" r="3" {...stroke} />
        <path
          d="M19 12a7 7 0 0 0-.15-1.5l2-1.6-2-3.5-2.5 1a7 7 0 0 0-2.6-1.5L13.5 3h-3L10.25 5.4a7 7 0 0 0-2.6 1.5l-2.5-1-2 3.5 2 1.6A7 7 0 0 0 5 12c0 .5.05 1 .15 1.5l-2 1.6 2 3.5 2.5-1a7 7 0 0 0 2.6 1.5L10.5 21h3l.25-2.4a7 7 0 0 0 2.6-1.5l2.5 1 2-3.5-2-1.6c.1-.5.15-1 .15-1.5Z"
          {...stroke}
        />
      </>
    ),
    pin: <path d="M12 21v-6M8 9V3h8v6l3 4v2H5v-2l3-4Z" {...stroke} />,
  };

  return (
    <svg viewBox="0 0 24 24" style={s} role="img" aria-label={title}>
      {title ? <title>{title}</title> : null}
      {paths[name]}
    </svg>
  );
}
